import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { FileText, Book } from "lucide-react";

import LocalIcon from "./icons/LOCAL";

gsap.registerPlugin(ScrollTrigger);

const Header: React.FC = () => {
  const headerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (headerRef.current) {
      const headerElement = headerRef.current;

      // Set initial position
      gsap.set(headerElement, { y: "-100%" });

      ScrollTrigger.create({
        trigger: document.body,
        start: "top top",
        end: "bottom bottom",
        onUpdate: (self) => {
          if (self.progress > 0.05) {
            gsap.to(headerElement, {
              y: "0%",
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              boxShadow:
                "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
              duration: 0.1,
              ease: "power2.out",
            });
          } else {
            gsap.to(headerElement, {
              y: "-100%",
              backgroundColor: "transparent",
              boxShadow: "none",
              duration: 0.1,
              ease: "power2.in",
            });
          }
        },
      });
    }

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <header
      ref={headerRef}
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-200 -translate-y-full"
    >
      <nav className="container mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          <LocalIcon className="w-[100px] h-9" />
          <div className="flex md:hidden space-x-4">
            <a
              href="https://palette-labs-inc.github.io/"
              target="_blank"
              rel="noreferrer"
              className="text-gray-800 hover:text-local-green transition-colors duration-200"
            >
              <FileText className="w-6 h-6" />
            </a>
            <a
              href="https://docs.localprotocol.xyz"
              target="_blank"
              rel="noreferrer"
              className="text-gray-800 hover:text-local-green transition-colors duration-200"
            >
              <Book className="w-6 h-6" />
            </a>
          </div>
          <div className="hidden md:flex space-x-6">
            <a
              href="https://palette-labs-inc.github.io/"
              target="_blank"
              rel="noreferrer"
              className="text-gray-800 hover:text-local-green font-medium text-base transition-colors duration-200 relative group"
            >
              White Paper
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-local-green transform scale-x-0 group-hover:scale-x-100 transition-transform duration-200 ease-out"></span>
            </a>
            <a
              href="https://docs.localprotocol.xyz"
              target="_blank"
              rel="noreferrer"
              className="text-gray-800 hover:text-local-green font-medium text-base transition-colors duration-200 relative group"
            >
              Docs
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-local-green transform scale-x-0 group-hover:scale-x-100 transition-transform duration-200 ease-out"></span>
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
